import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Divider,
  Tag,
} from 'antd';

import moment from 'moment';
import {
  formatCell,
  sorter,
  createColumns,
  uuid,
} from '../../../helpers';

import DataTable from '../../DataTable';
import { Spinner } from '../../UI';
import { Filters } from '../../../containers/Filters';

const { Title } = Typography;

class History extends PureComponent {
  state = {
    aff: '',
    timeZone: '',
    sixMonthsAgo: moment().subtract(6, 'months').format('YYYY-MM-DD'),
    today: moment(new Date()).format('YYYY-MM-DD'),
  };

  componentDidMount () {
    this.props.fetchUserInfo(() => {
      const payload = {
        dt1: this.state.sixMonthsAgo,
        dt2: this.state.today,
        timeZone: this.props.user.time_zone,
        aff: ''
      };

      this.setState({
        dt1: payload.dt1,
        dt2: payload.dt2,
        timeZone: payload.timeZone,
        aff: payload.aff,
      });

      this.aff();
      this.props.fetchPaymentsHistory(payload);
    });
  };

  aff = () => {
    const firstAff = {
      rowId: uuid(),
      aff: ''
    };
    const affList = [firstAff, ...this.props.user.affList];

    this.setState({
      affList: affList
    });
  };

  saff = () => {
    const firstSaff = {
      rowId: uuid(),
      saff: ''
    };
    const saffList = [firstSaff, ...this.props.saff];

    this.setState({
      saffList: saffList
    });
  };

  handleChange = (date, dateString) => {
    const [dt1, dt2] = dateString;
    this.setState({
      dt1,
      dt2
    });

    const payload = {
      dt1,
      dt2,
      aff: this.state.aff,
      timeZone: this.state.timeZone,
    };

    this.handleChangeFilter(payload);
  };

  handleSelect = (value) => {
    this.setState({
      aff: value
    });

    const payload = {
      dt1: this.state.dt1 ? this.state.dt1 : this.state.sixMonthsAgo,
      dt2: this.state.dt2 ? this.state.dt2 : this.state.today,
      aff: value,
      timeZone: this.state.timeZone,
    };

    this.handleChangeFilter(payload);
  };

  handleChangeFilter = (payload) => {
    this.props.setFilter({
      ...this.props.filters,
      ...payload,
    });
    this.props.fetchPaymentsHistory(payload);
  };

  render() {
    const {
      pageLoading,
      loading,
      paymentsList,
      paymentsList: {
        fields,
        tableName,
      }
    } = this.props;
    const fieldsObj = fields && fields[0];

    const renderTableCell = (text, record, item) => {
      const answer = (text === '1') ? 'YES' : 'NO';
      const {
        isLabel,
        name,
      } = item;

      let content = text;
      if (isLabel) {
        content = <Tag color={text === '1' ? '#87d068' : '#f50'}>{answer}</Tag>;
      }

      if (name === 'Date') {
        content = <span className="text-nowrap">{content}</span>
      }

      return formatCell(item, content);
    };

    const columns = createColumns(
      fieldsObj,
      sorter,
      renderTableCell,
    );

    let content = <Spinner />;
    if (!pageLoading) {
      content = (
        <>
          <Divider />
          <Filters
            defaultDate={[moment().subtract(6, 'months'), moment()]}
            handleSelect={this.handleSelect}
            handleChange={this.handleChange}
            subs={false}
          />
          <DataTable
            loading={loading}
            table={{
              columns: columns,
              data: paymentsList,
              tableName: tableName,
              toolbar: {
                titleExport: 'Payments History Export',
              }
            }}
          />
        </>
      );
    }

    return (
      <div>
        <Title>History</Title>
        {content}
      </div>
    );
  }
}

History.propTypes = {
  pageLoading: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  paymentsList: PropTypes.object.isRequired,
  fetchUserInfo: PropTypes.func.isRequired,
  fetchPaymentsHistory: PropTypes.func.isRequired,
};

History.defaultProps = {
  paymentsList: {}
};

export default History;
